import { useDispatch } from 'react-redux'
import { CompanyAdd } from '../../Views/Company/CompanyAdd/CompanyAdd'
import { Popup } from '../Popup/Popup'
import { closeCurrentPopup } from '../../Store/InterfaceSlice'
import { useLocalization } from '../../Hooks/useLocalization'

export function CreateCompanyPopup() {
  const dispatch = useDispatch()
  const localization = useLocalization('company')
  return (
    <Popup
      className="create-company-popup"
      title={localization.text('add-company', 'Voeg onderneming toe')}
    >
      <CompanyAdd onSaveAction={() => dispatch(closeCurrentPopup())} />
    </Popup>
  )
}
